// <hd-carousel>: previous/next buttons for a horizontally scrolling track.
// Markup: <hd-carousel><button data-prev>…</button><div data-track>…</div><button data-next>…</button></hd-carousel>
class HdCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.prev = this.querySelector('[data-prev]');
    this.next = this.querySelector('[data-next]');
    if (!this.track) return;
    this.prev?.addEventListener('click', () => this.go(-1));
    this.next?.addEventListener('click', () => this.go(1));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    window.addEventListener('resize', () => this.update());
    this.update();
  }

  // Scroll by the number of cards currently visible.
  go(dir) {
    const card = this.track.firstElementChild;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
    const perView = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollBy({ left: dir * step * perView, behavior: reduce ? 'auto' : 'smooth' });
  }

  update() {
    const max = this.track.scrollWidth - this.track.clientWidth - 2;
    const atStart = this.track.scrollLeft <= 2;
    const atEnd = this.track.scrollLeft >= max;
    if (this.prev) this.prev.disabled = atStart;
    if (this.next) this.next.disabled = atEnd;
    this.toggleAttribute('data-static', max <= 0);
  }
}
if (!customElements.get('hd-carousel')) customElements.define('hd-carousel', HdCarousel);
